/* FoodNet Express — mobile-first delivery page */
(function foodnetDeliveryPage() {
  'use strict';

  if (window.__foodnetDeliveryPage) return;
  window.__foodnetDeliveryPage = true;

  const root = document.querySelector('[data-fn-delivery]');
  if (!root) return;

  const BRUGGE = { lat: 51.2089, lon: 3.2242 };
  const POSTCODE_KEY = 'foodnet_delivery_postcode';
  const LOOKUP_TIMEOUT_MS = 8000;

  const zones = [
    {
      key: '20',
      maxKm: 20,
      label: '0–20 km',
      minSubtotal: Number(root.dataset.zone20Min || 4000),
      fee: Number(root.dataset.zone20Fee || 700)
    },
    {
      key: '50',
      maxKm: 50,
      label: '20–50 km',
      minSubtotal: Number(root.dataset.zone50Min || 30000),
      fee: Number(root.dataset.zone50Fee || 2000)
    },
    {
      key: '100',
      maxKm: 100,
      label: '50–100 km',
      minSubtotal: Number(root.dataset.zone100Min || 50000),
      fee: Number(root.dataset.zone100Fee || 4000)
    }
  ];

  const ui = {
    form: root.querySelector('[data-fn-delivery-form]'),
    input: root.querySelector('[data-fn-delivery-postcode]'),
    button: root.querySelector('[data-fn-delivery-check]'),
    status: root.querySelector('[data-fn-delivery-status]'),
    result: root.querySelector('[data-fn-delivery-result]'),
    resultIcon: root.querySelector('[data-fn-delivery-result-icon]'),
    resultKicker: root.querySelector('[data-fn-delivery-result-kicker]'),
    resultTitle: root.querySelector('[data-fn-delivery-result-title]'),
    resultCopy: root.querySelector('[data-fn-delivery-result-copy]'),
    place: root.querySelector('[data-fn-delivery-place]'),
    zone: root.querySelector('[data-fn-delivery-zone]'),
    minimum: root.querySelector('[data-fn-delivery-minimum]'),
    fee: root.querySelector('[data-fn-delivery-fee]'),
    cartState: root.querySelector('[data-fn-delivery-cart-state]'),
    cartLabel: root.querySelector('[data-fn-delivery-cart-label]'),
    cartValue: root.querySelector('[data-fn-delivery-cart-value]'),
    progress: root.querySelector('[data-fn-delivery-progress]'),
    progressBar: root.querySelector('[data-fn-delivery-progress-bar]'),
    primary: root.querySelector('[data-fn-delivery-primary]')
  };

  let cart = null;
  let postcodeState = null;
  let lookupBusy = false;
  let autocheckTimer = 0;
  let activeController = null;
  let requestSequence = 0;

  const cleanPostcode = (value) =>
    String(value || '').replace(/\D/g, '').slice(0, 4);

  const money = (cents) => {
    const euros = (Number(cents) || 0) / 100;
    const digits = Number.isInteger(euros) ? 0 : 2;
    return new Intl.NumberFormat('nl-BE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(euros).replace(/[\u00a0\u202f]/g, ' ');
  };

  const subtotal = () =>
    Number(cart?.items_subtotal_price ?? cart?.total_price ?? 0);

  const itemCount = () => Number(cart?.item_count || 0);

  const setText = (element, value) => {
    if (element) element.textContent = value;
  };

  const setStatus = (message = '', state = '') => {
    if (!ui.status) return;
    ui.status.textContent = message;
    ui.status.dataset.state = state;
    ui.status.hidden = !message;
  };

  const setBusy = (busy) => {
    lookupBusy = busy;
    if (ui.button) {
      ui.button.disabled = busy;
      ui.button.textContent = busy ? 'Controleren…' : 'Controleer';
    }
    if (ui.input) ui.input.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  const haversineKm = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => value * Math.PI / 180;
    const radius = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;
    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const zoneFor = (distanceKm) =>
    zones.find((zone) => distanceKm <= zone.maxKm) || null;

  const setPrimary = (label, url) => {
    if (!ui.primary) return;
    ui.primary.textContent = label;
    ui.primary.href = url;
  };

  const highlightZone = (zone) => {
    root.querySelectorAll('[data-fn-delivery-zone-card]').forEach((card) => {
      card.classList.toggle('is-active', Boolean(zone) && card.dataset.fnDeliveryZoneCard === zone.key);
    });
  };

  const setProgress = (current, target) => {
    if (!ui.progress || !ui.progressBar) return;
    const percent = target > 0
      ? Math.max(0, Math.min(100, Math.round((current / target) * 100)))
      : 0;
    ui.progress.setAttribute('aria-valuenow', String(percent));
    ui.progress.setAttribute('aria-valuetext', `${percent}% van het minimumbedrag`);
    ui.progressBar.style.width = `${percent}%`;
  };

  const render = () => {
    if (!ui.result) return;

    ui.result.classList.remove('is-ready', 'is-short', 'is-outside', 'is-unverified');
    highlightZone(postcodeState?.zone || null);

    if (!postcodeState) {
      ui.result.hidden = true;
      return;
    }

    ui.result.hidden = false;
    setText(ui.place, [postcodeState.postcode, postcodeState.place].filter(Boolean).join(' '));

    if (postcodeState.unverified) {
      ui.result.classList.add('is-unverified');
      setText(ui.resultIcon, 'i');
      setText(ui.resultKicker, 'Controle tijdelijk niet beschikbaar');
      setText(ui.resultTitle, 'We konden je zone niet bepalen');
      setText(
        ui.resultCopy,
        'Je postcode is onthouden. Je kunt verder winkelen; FoodNet controleert het volledige afleveradres bij je bestelling.'
      );
      setText(ui.zone, 'Nog te controleren');
      setText(ui.minimum, 'Na adrescontrole');
      setText(ui.fee, 'Na adrescontrole');
      if (ui.cartState) ui.cartState.hidden = true;
      setPrimary(
        itemCount() > 0 ? 'Bekijk winkelwagen' : 'Bekijk producten',
        itemCount() > 0 ? root.dataset.cartUrl : root.dataset.shopUrl
      );
      return;
    }

    if (postcodeState.outside || !postcodeState.zone) {
      ui.result.classList.add('is-outside');
      setText(ui.resultIcon, '!');
      setText(ui.resultKicker, 'Buiten het standaardgebied');
      setText(ui.resultTitle, 'FoodNet bezorgt hier niet standaard');
      setText(
        ui.resultCopy,
        'Deze postcode ligt verder dan 100 km van Brugge. Neem contact op als je een grotere zakelijke bestelling wilt bespreken.'
      );
      setText(ui.zone, 'Meer dan 100 km');
      setText(ui.minimum, 'Niet beschikbaar');
      setText(ui.fee, 'Op aanvraag');
      if (ui.cartState) ui.cartState.hidden = true;
      setPrimary('Neem contact op', root.dataset.contactUrl || '/pages/contact');
      return;
    }

    const zone = postcodeState.zone;
    const currentSubtotal = subtotal();
    const missing = Math.max(0, zone.minSubtotal - currentSubtotal);
    const hasItems = itemCount() > 0;
    const ready = missing === 0 && hasItems;

    ui.result.classList.add(ready ? 'is-ready' : 'is-short');
    setText(ui.resultIcon, ready ? '✓' : '€');
    setText(ui.resultKicker, `${postcodeState.postcode} · ${zone.label}`);
    setText(
      ui.resultTitle,
      ready ? 'Je bestelling kan worden bezorgd' : 'Je postcode valt in ons bezorggebied'
    );

    if (!hasItems) {
      setText(
        ui.resultCopy,
        `Voor deze zone bestel je vanaf ${money(zone.minSubtotal)}. Voeg producten toe wanneer je klaar bent om te bestellen.`
      );
    } else if (missing > 0) {
      setText(
        ui.resultCopy,
        `Je hebt nog ${money(missing)} aan producten nodig om het minimum voor deze zone te bereiken.`
      );
    } else {
      setText(
        ui.resultCopy,
        `Je winkelwagen voldoet aan het minimum. FoodNet bezorgt deze bestelling zelf voor ${money(zone.fee)}.`
      );
    }

    setText(ui.zone, zone.label);
    setText(ui.minimum, money(zone.minSubtotal));
    setText(ui.fee, money(zone.fee));

    if (ui.cartState) ui.cartState.hidden = false;
    if (!hasItems) {
      setText(ui.cartLabel, 'Winkelwagen');
      setText(ui.cartValue, 'Nog leeg');
    } else if (missing > 0) {
      setText(ui.cartLabel, 'Nog nodig');
      setText(ui.cartValue, money(missing));
    } else {
      setText(ui.cartLabel, 'Minimum bereikt');
      setText(ui.cartValue, money(currentSubtotal));
    }
    setProgress(currentSubtotal, zone.minSubtotal);

    setPrimary(
      ready ? 'Bekijk winkelwagen' : 'Bekijk producten',
      ready ? root.dataset.cartUrl : root.dataset.shopUrl
    );
  };

  const deliveryAttributes = () => {
    const zone = postcodeState?.zone || null;
    const missing = zone ? Math.max(0, zone.minSubtotal - subtotal()) : 0;
    return {
      'Bezorgmethode': zone && missing === 0 ? 'FoodNet eigen levering' : '',
      'Bezorgpostcode': postcodeState?.postcode || '',
      'Bezorgplaats': postcodeState?.place || '',
      'Bezorgzone': zone?.label || '',
      'Bezorgtarief': zone ? money(zone.fee) : '',
      'Bezorgstatus': postcodeState?.unverified
        ? 'Adrescontrole nodig'
        : postcodeState?.outside
          ? 'Buiten standaardgebied'
          : zone && missing === 0
            ? 'Beschikbaar'
            : zone
              ? 'Minimum niet bereikt'
              : 'Postcode nodig'
    };
  };

  const persistDelivery = async () => {
    if (!cart || itemCount() < 1 || !postcodeState) return;

    const attributes = {
      ...(cart.attributes || {}),
      ...deliveryAttributes()
    };
    const unchanged = Object.entries(deliveryAttributes()).every(
      ([key, value]) => String(cart.attributes?.[key] || '') === String(value || '')
    );
    if (unchanged) return;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) return;
      const nextCart = await response.json();
      if (nextCart && typeof nextCart === 'object') cart = nextCart;
    } catch (error) {
      /* The postcode remains available in localStorage if cart persistence fails. */
    }
  };

  const announceState = () => {
    window.dispatchEvent(new CustomEvent('wokora:delivery-page-updated', {
      detail: {
        postcode: postcodeState?.postcode || '',
        place: postcodeState?.place || '',
        zone: postcodeState?.zone?.label || '',
        outside: Boolean(postcodeState?.outside),
        unverified: Boolean(postcodeState?.unverified)
      }
    }));
  };

  const checkPostcode = async (rawPostcode, { persist = true } = {}) => {
    const postcode = cleanPostcode(rawPostcode);
    if (ui.input) ui.input.value = postcode;

    if (!/^[1-9][0-9]{3}$/.test(postcode)) {
      postcodeState = null;
      if (ui.input) ui.input.setAttribute('aria-invalid', 'true');
      setStatus('Vul een geldige Belgische postcode van vier cijfers in.', 'error');
      render();
      return;
    }

    if (ui.input) ui.input.removeAttribute('aria-invalid');
    activeController?.abort();
    const controller = new AbortController();
    activeController = controller;
    const sequence = ++requestSequence;
    const timeout = window.setTimeout(() => controller.abort(), LOOKUP_TIMEOUT_MS);

    setBusy(true);
    setStatus('Je postcode wordt gecontroleerd…', 'loading');

    try {
      const response = await fetch(
        `https://api.zippopotam.us/be/${encodeURIComponent(postcode)}`,
        {
          headers: { Accept: 'application/json' },
          credentials: 'omit',
          referrerPolicy: 'no-referrer',
          cache: 'force-cache',
          signal: controller.signal
        }
      );
      if (response.status === 404) throw new Error('postcode-not-found');
      if (!response.ok) throw new Error('postcode-service-unavailable');

      const data = await response.json();
      const place = data?.places?.[0];
      const latitude = Number(place?.latitude);
      const longitude = Number(place?.longitude);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        throw new Error('postcode-service-unavailable');
      }
      if (sequence !== requestSequence) return;

      const distance = haversineKm(BRUGGE.lat, BRUGGE.lon, latitude, longitude);
      const zone = zoneFor(distance);
      postcodeState = {
        postcode,
        place: String(place?.['place name'] || '').trim(),
        distance,
        zone,
        outside: !zone,
        unverified: false
      };

      try {
        window.localStorage.setItem(POSTCODE_KEY, postcode);
      } catch (error) {
        /* Storage can be unavailable in private browsing; the page still works. */
      }

      setStatus(
        zone ? 'Je postcode is gecontroleerd.' : 'Je postcode ligt buiten het standaardgebied.',
        zone ? 'success' : 'neutral'
      );
      render();
      if (persist) await persistDelivery();
      announceState();
    } catch (error) {
      if (error?.name === 'AbortError' && sequence !== requestSequence) return;
      if (sequence !== requestSequence) return;

      if (error?.message === 'postcode-not-found') {
        postcodeState = null;
        if (ui.input) ui.input.setAttribute('aria-invalid', 'true');
        setStatus('Deze Belgische postcode werd niet gevonden. Controleer je invoer.', 'error');
      } else {
        postcodeState = {
          postcode,
          place: '',
          distance: null,
          zone: null,
          outside: false,
          unverified: true
        };
        try {
          window.localStorage.setItem(POSTCODE_KEY, postcode);
        } catch (storageError) {
          /* The customer can still continue without local persistence. */
        }
        setStatus('De postcodecontrole is tijdelijk niet beschikbaar.', 'neutral');
        render();
        if (persist) await persistDelivery();
        announceState();
      }
      render();
    } finally {
      window.clearTimeout(timeout);
      if (sequence === requestSequence) setBusy(false);
    }
  };

  const restorePostcode = async () => {
    let saved = cleanPostcode(cart?.attributes?.Bezorgpostcode || '');
    if (!saved) {
      try {
        saved = cleanPostcode(window.localStorage.getItem(POSTCODE_KEY) || '');
      } catch (error) {
        saved = '';
      }
    }
    if (!saved || !ui.input) return;
    ui.input.value = saved;
    await checkPostcode(saved, { persist: false });
  };

  const acceptCartUpdate = (nextCart) => {
    if (!nextCart || typeof nextCart !== 'object') return;
    cart = nextCart;
    render();
    if (postcodeState) persistDelivery();
  };

  ui.form?.addEventListener('submit', (event) => {
    event.preventDefault();
    window.clearTimeout(autocheckTimer);
    if (!lookupBusy) checkPostcode(ui.input?.value || '');
  });

  ui.input?.addEventListener('input', () => {
    const cleaned = cleanPostcode(ui.input.value);
    if (ui.input.value !== cleaned) ui.input.value = cleaned;
    ui.input.removeAttribute('aria-invalid');
    window.clearTimeout(autocheckTimer);

    if (lookupBusy) {
      activeController?.abort();
      requestSequence += 1;
      setBusy(false);
    }

    if (postcodeState && cleaned !== postcodeState.postcode) {
      postcodeState = null;
      setStatus();
      render();
    }

    if (cleaned.length < 4) setStatus();

    if (/^[1-9][0-9]{3}$/.test(cleaned) && !lookupBusy) {
      autocheckTimer = window.setTimeout(() => checkPostcode(cleaned), 450);
    }
  });

  window.addEventListener('wokora:cart-v73', (event) => {
    acceptCartUpdate(event.detail?.cart);
  });

  document.addEventListener('wokora:cart-updated', (event) => {
    acceptCartUpdate(event.detail?.cart);
  });

  fetch('/cart.js', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
    cache: 'no-store'
  })
    .then((response) => response.ok ? response.json() : Promise.reject())
    .then(async (data) => {
      cart = data;
      render();
      await restorePostcode();
    })
    .catch(async () => {
      cart = { item_count: 0, total_price: 0, items_subtotal_price: 0, attributes: {} };
      render();
      await restorePostcode();
    });
})();
